export const BASEURL = 'https://api.isac.happay.in/';
